module.exports = __webpack_public_path__ + "img/phone.ee72b65b.jpg";